export const JOB_POSITION = 'position/job/'
export const JOB_POSITION_ALL = `${JOB_POSITION}all`
export const JOB_POSITION_ACTIVATE = `${JOB_POSITION}activate/`
